import { Form } from 'antd';
import { AppFormSection } from '../../../../../../ui/AppFormSection';
import { AppNewSelect } from '../../../../../../ui/AppNewSelect';
import { SurveyType } from '../../utils/consts';
import { useLocalization } from '../../../../../../lib/hooks/useLocalization';
import { handleTranslation } from '../../../../../../lib/util/helpers';
import { FormItemName } from '../../../../../../lib/models/Form';

export function SurveyTypeFormItem() {
  const { general } = useLocalization().translations.unique.pages.settings;

  const options = [
    {
      value: SurveyType.QUESTION_BASED,
      title: handleTranslation(general.questionBased),
    },
    {
      value: SurveyType.PRODUCT_BASED,
      title: handleTranslation(general.productBased),
    },
  ];

  return (
    <AppFormSection>
      <Form.Item name={FormItemName.SURVEY_TYPE} style={{ minHeight: 40, minWidth: 226 }}>
        <AppNewSelect options={options} placeholder={general.chooseSurveyType} />
      </Form.Item>
    </AppFormSection>
  );
}
